import api from "./client";

// Probation reviews (admin side is Fan only; the self-review side is the account manager's own).
export const getStaffReviews = () => api.get("/admin/staff-reviews");
export const getStaffReview = (id) => api.get(`/admin/staff-reviews/${id}`);
export const runStaffReviews = () => api.post("/admin/staff-reviews/run");
export const createStaffReview = (email, number) => api.post("/admin/staff-reviews/create", { email, number });
export const saveStaffReviewStandards = (email, body) => api.put(`/admin/staff-reviews/standards/${encodeURIComponent(email)}`, body);
export const saveStaffReviewSettings = (body) => api.put("/admin/staff-reviews/settings", body);
export const refreshStaffReview = (id, ai = true) => api.post(`/admin/staff-reviews/${id}/refresh`, null, { params: { ai } });
export const saveStaffReviewManager = (id, body) => api.put(`/admin/staff-reviews/${id}/manager`, body);
export const requestStaffSelfReview = (id) => api.post(`/admin/staff-reviews/${id}/request-self-review`);
export const setStaffReviewDecision = (id, body) => api.put(`/admin/staff-reviews/${id}/decision`, body);
export const saveStaffReviewLetter = (id, letter) => api.put(`/admin/staff-reviews/${id}/letter`, { letter });
export const signOffStaffReview = (id) => api.post(`/admin/staff-reviews/${id}/sign-off`);
export const reopenStaffReview = (id) => api.post(`/admin/staff-reviews/${id}/reopen`);
export const downloadStaffReviewPdf = (id, shared = false) =>
  api.get(`/admin/staff-reviews/${id}/pdf`, { responseType: "blob", params: shared ? { shared: true } : undefined });

export const getMyReviews = () => api.get("/my-portfolio/reviews");
export const getMyReview = (id) => api.get(`/my-portfolio/reviews/${id}`);
export const saveMySelfReview = (id, body) => api.put(`/my-portfolio/reviews/${id}/self`, body);
